export const SET_ROUTE_SERVICES = "setRouteServices";
export const CLIENT_FILTER_CHANGED = "clientFilterChanged";
export const VEHICLE_FILTER_CHANGED = "vehicleFilterChanged";
export const SEARCH_TEXT_CHANGED = "searchTextChanged";
export const UPDATE_TOTAL_SERVICES_COUNT = "updateTotalServicesCount";
export const TOGGLE_UPDATE_INDICATOR = "toggleUpdateIndicator";
